export default __webpack_public_path__ + "static/media/ethereum-logo.27f54c9b.png";